import './App.css';
import Doners from './components/Doners/Doners';
import Footer from './components/Footer/Footer';
import Header from './components/Header/Header';


function App() {
  return (
    <div className="">
      <Header></Header>
      <Doners></Doners>
      <Footer></Footer>
    </div>
  );
}

export default App;
